export default __webpack_public_path__ + "3f17ce9030964e6c8c0b9598dc7be23a.woff";